import React from "react"
import BrandFooter from "../components/BrandFooter/BrandFooter"

function BrandFooterRegion() {
  return <footer className="brand-footer" role="contentinfo">
    <BrandFooter />
  </footer>
}

export default BrandFooterRegion
